// Empty links (WCAG 2.4.4, 4.1.2): authored rich text sometimes leaves a link
// around nothing but a space (<a href="...">&nbsp;</a>). It is invisible on
// the page, but keyboard users still Tab onto it and screen readers announce a
// link with no name. Such links are taken out of the Tab order and hidden from
// assistive technology; links with text, an image with alt text, a labelled
// icon or an aria-label are left alone. Authors should still remove them.
function hasContent(link) {
    if (link.getAttribute("aria-label") || link.getAttribute("aria-labelledby") || link.title) {
        return true;
    }
    if (link.textContent.replace(/ /g, " ").trim()) {
        return true;
    }
    return !!link.querySelector("img, svg, picture, video, iframe, input, button, [role=img]");
}

function hideEmptyLinks() {
    document.querySelectorAll("a[href]").forEach((link) => {
        if (!hasContent(link)) {
            link.setAttribute("aria-hidden", "true");
            link.setAttribute("tabindex", "-1");
        }
    });
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", hideEmptyLinks);
} else {
    hideEmptyLinks();
}
